import React, { useReducer } from "react";
import BlueInfoBox from "../../../yoello-lib/modules/components/UI/BlueInfoBox/BlueInfoBox";
import { AddCreateMenuButtons } from "../ui/AddCreateMenuButtons";
import ISubCategory from "../../menu/categories/ISubCategory";
import { useTranslation } from "react-i18next";
import IMenuItemBody from "../../../interfaces/IMenuItemBody";
import { ManageMenuReducer } from "../state";
import { manageMenuInitalState } from "../ManageMenuItemContainer";
import { IMenuData } from "../types";
import { useHistory } from "react-router";
import { useDialogRouteStages } from "../../dialogRoutes/useDialogRouteStages";
import { ADD_ITEM, CREATE_URL, MENU_URL, PRODUCTS_ITEMS_URL, PRODUCTS_MANAGE_MENU_URL } from "../../../const/URL.const";
export interface IAddToMenuController {
    subcategories: ISubCategory[];
    menuItems: IMenuItemBody[];
    venueId: string;
    manageMenuAPI: any;
    orphanedMenuItemsAPI: any;
    menuItemsNotInMenu: IMenuItemBody[];
    menusList: IMenuData[];
    addBoxExtraInfo?: string;
    updateData?: (updatedItems: IMenuItemBody[], updatedMenus?: IMenuData[]) => void;
    updateMenusListAPI?: any;
}

export function AddToMenuController({
    subcategories,
    menuItems,
    orphanedMenuItemsAPI,
    menuItemsNotInMenu,
    menusList,
    addBoxExtraInfo,
    updateData,
    updateMenusListAPI
}: IAddToMenuController) {
    const { t } = useTranslation();
    const history = useHistory();
    const { goToNextStep } = useDialogRouteStages(history);

    const [state] = useReducer(
        ManageMenuReducer,
        manageMenuInitalState
    );


    function onCreateMenuClick() {
        goToNextStep("menu", {
            ComponentProps: {
                menuItemsList: menuItems,
                itemData: state.menuFormData,
                onClose: () => history.push(PRODUCTS_ITEMS_URL),
                subcategories: subcategories,
                orphanedMenuItemsAPI: orphanedMenuItemsAPI,
                updateData,
                updateMenusListAPI
            },
            dialogTitle: t('manageMenu.manageMenuContainer.create'),
        }, `${PRODUCTS_MANAGE_MENU_URL}/${CREATE_URL}`)
    }

    function onAddItemsToMenuClick() {
        history.push(`${PRODUCTS_ITEMS_URL}${MENU_URL}${ADD_ITEM}`)
    }

    return <div>
        {
            menuItemsNotInMenu.length > 0 && <BlueInfoBox style={{
                marginTop: "0"
            }} Info={t('manageMenu.manageMenuContainer.ItemsNotVisible', {
                itemsCount: menuItemsNotInMenu.length
            })} ExtraInfo={addBoxExtraInfo ?? undefined} Buttons={<AddCreateMenuButtons onAddItemsToMenuClick={onAddItemsToMenuClick} onCreateMenuClick={onCreateMenuClick} hasAddButton={menusList.length > 0} />} />

        }
    </div>
}